// extracted by mini-css-extract-plugin
export default {"background":"iE","weightImage":"jE","drinkImage":"kE","content":"lE","rtbLeft":"mE","rtbRight":"nE","rtbLeftMobile":"oE","imageContainer":"pE","rtbBox":"qE","line":"rE","rtbDesktop":"sE"};
    if(module.hot) {
      // 1715276856625
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  